import { useStore } from 'effector-react'
import * as React from 'react'

import { $exchangerTransfer, exchangerTransferMounted } from './model'

export const useExchangerTransfer = () => {
  const exchangerTransfer = useStore($exchangerTransfer)

  React.useEffect(() => {
    exchangerTransferMounted()
  }, [])

  return { exchangerTransfer }
}
